import { ethers } from 'ethers'

export const buyTicket = async (contract, numbers) => {
  return contract.BuyYourTicket(numbers)
}

export const bribeSpin = async (contract) => {
  return contract.bribe_SpinWheel()
}

export const approve = async (contract, spender) => {
  return contract.approve(spender, ethers.constants.MaxUint256)
}

export const claimReward = async (contract) => {
  return contract.claimWinnerReward()
}
